
import { BUSINESS_UNIT_METADATA } from './business-unit.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class BusinessUnitAddressMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('BusinessUnitAddress', {
      businessUnitAddressId: <PropertyMetadata> {
        name: 'businessUnitAddressId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        precision: 8,
        unique: true
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      addr1: <PropertyMetadata> {
        name: 'addr1',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      addr2: <PropertyMetadata> {
        name: 'addr2',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      addr3: <PropertyMetadata> {
        name: 'addr3',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      addrType: <PropertyMetadata> {
        name: 'addrType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 2,
        unique: false
      },
      county: <PropertyMetadata> {
        name: 'county',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      description: <PropertyMetadata> {
        name: 'description',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      postcode: <PropertyMetadata> {
        name: 'postcode',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 8,
        unique: false
      },
      town: <PropertyMetadata> {
        name: 'town',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.businessUnitAddressId;
    return nullIfContainsNull(result);
  }
}



